import { render, staticRenderFns } from "./StaffAutoComplete.vue?vue&type=template&id=2858fdb9"
import script from "./StaffAutoComplete.vue?vue&type=script&lang=js"
export * from "./StaffAutoComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports